import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@mui/material';

import { StyledPrimaryButton } from './styles';

const PrimaryButton = ({
  onClick,
  children,
  disabled,
  type,
  className,
  icon,
  endIcon,
  variant,
  size,
  $fitToContent,
  ...props
}) => (
  <StyledPrimaryButton
    onClick={onClick}
    startIcon={icon}
    endIcon={endIcon}
    component={Button}
    disabled={disabled}
    type={type}
    className={className}
    $variant={variant}
    $size={size}
    $fitToContent={$fitToContent}
    {...props}
  >
    {children}
  </StyledPrimaryButton>
);

PrimaryButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  endIcon: PropTypes.element,
  className: PropTypes.string,
  type: PropTypes.oneOf(['submit', 'button']),
  variant: PropTypes.oneOf(['dark', 'light', 'info', 'warning', 'dimmed', 'danger']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  $fitToContent: PropTypes.bool,
};

PrimaryButton.defaultProps = {
  children: [],
  onClick: null,
  disabled: false,
  type: 'button',
  icon: null,
  endIcon: null,
  variant: 'dark',
  size: 'large',
  $fitToContent: false,
  className: '',
};

export default PrimaryButton;
